import React, { useEffect } from "react";
import BlogCard from "../../components/cards/BlogCard";
import MobileHeader from "../../layout/MobileHeader";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";
import Icon from "../../components/Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { dateFormat } from "../../utils";

const Blogs = ({ blogs=[], fitlers={}, setFilters = () => {} }) => {
  const navigate = useNavigate()
  const searchParams = useSearchParams()
  const search = searchParams[0].get("search")

  useEffect(() => {
    setFilters({ ...fitlers, search })
  }, [ search ])

  return (
    <>
      <MobileHeader height={"237px"}>
        <MobileHeaderSearch placeholder="Search for blogs and Stories" onSearch={ search => setFilters({ search })} />
      </MobileHeader>

      <section style={{ marginTop: "270px" }}>
        <div className="px-3 p-0">
          <div className="top-heading">Latest Blog &amp; News</div>
          <div className="top-destinations-subHeading mt-2">
            Making the Most of Your Travel Experience in 2024
          </div>
        </div>

        {fitlers.search && <h4 className="custom-text-color my-4 container">Search: { fitlers.search } <Icon icon={faXmark} className="text-danger ms-2 cursor-pointer" onClick={() => (setFilters({}), navigate('/blogs'))} /></h4>}

        <div className="mt-4 px-2">
          <div className="d-flex row flex-nowrap overflow-auto scrollbar-hidden p-0 ">
            {blogs.map((blog, i) => (
              <div key={i} className="col-lg-4 col-md-8 col-sm-8">
                <div className="m-2">
                  <BlogCard data={blog} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/*links  */}
      <div className="px-3">
        <div className="row m-0 mt-3 flex-nowrap  scrollbar-hidden">
          {blogs?.map((blog, i) => (
              <div className="col-10 primary-border bg-light mx-2 p-3 " key={i}>
                <ul className="d-flex gap-4 mx-0 px-3">
                  <li className="fs-9 text-info">{ dateFormat(blog.createdAt) }</li>
                  <li className="fs-9 text-info">{ blog.cityId?.name }</li>
                </ul>
                <h6 className="link-card-title">
                  { blog?.title }
                </h6>
                <div className="link-card-text">{ blog.shortNote }
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default Blogs;
